// export const rootUrl = 'http://localhost:8082/pos-main';
export const rootUrl = process.env['NX_POS_API_URL'] || 'http://localhost:8080';
export const vaunceAppRootUrl = process.env['NX_SERVERINFO_API_URL'] || 'http://localhost:8090';
